import React from 'react';
import { Typography } from '@material-ui/core';
import Icon from '@mdi/react';
import pluralize from 'pluralize';
import styled from 'styled-components';
import { IconSize } from '../../../lib';
import { defaultMuiTheme } from '../../../styles/MaterialTheme';
const BREAKPOINT_500PX = 500;
const StatContainer = styled.div `
    display: flex;
    flex-wrap: nowrap;
    cursor: ${(props) => (props.$clickable ? 'pointer' : 'default')};
    padding-top: 1rem;

    ${defaultMuiTheme.breakpoints.down(BREAKPOINT_500PX)} {
        flex: 0 50%;
        padding: 0;
    }
`;
const StatIcon = styled(Icon) `
    color: ${(props) => props.theme.colors.textSecondary};
    margin-right: 0.5rem;

    ${defaultMuiTheme.breakpoints.down(BREAKPOINT_500PX)} {
        display: none;
    }
`;
const StatTotal = styled.span `
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;
    color: ${(props) => props.theme.colors.textSecondary};

    ${defaultMuiTheme.breakpoints.down(BREAKPOINT_500PX)} {
        margin-right: 0.5rem;
    }
`;
const StatInfoContainer = styled.div `
    display: flex;
    flex-direction: column;
    align-items: center;

    ${defaultMuiTheme.breakpoints.down(BREAKPOINT_500PX)} {
        flex-direction: row;
        align-items: flex-end;
    }
`;
const StatType = styled(Typography) `
    color: ${(props) => props.theme.colors.textSecondary};
    text-transform: uppercase;
`;
const FlexContainer = styled.div `
    display: flex;
`;
export const Stat = ({ total, label, icon, onClick }) => {
    return (React.createElement(StatContainer, { onClick: onClick, "$clickable": !!onClick },
        React.createElement(StatInfoContainer, null,
            React.createElement(FlexContainer, null,
                React.createElement(StatIcon, { path: icon, size: IconSize.Medium }),
                React.createElement(StatTotal, null, total.toLocaleString())),
            React.createElement(FlexContainer, null,
                React.createElement(StatType, { variant: "caption" }, pluralize(label, total))))));
};
//# sourceMappingURL=Stat.js.map